/**
 * A copy of a model with `changes` applied, keeping its class (prototype). Use it to update a cached model
 * immutably, so signal readers see a new instance. `model` is an already-built model, never hub input.
 */
export function withChanges<T extends object>(model: T, changes: Partial<T>): T {
  return Object.assign(Object.create(Object.getPrototypeOf(model)) as T, model, changes);
}
